import React from 'react';
import styled from 'styled-components';

import {yellowLargerIcon} from '../../Config/cardConfig.js'

import smartAutomationConfig from '../../data/smartAutomation.js'

const Subtitle = styled.div`
    display:flex;
    font-weight: 700;
    font-size:1.8rem;
    @media (max-width: 1000px) {
        font-size:1.4rem;
    }
    @media (max-width: 768px) {
        font-size: 1.2rem;
    }
` 

const Intro1ListWrapper = styled.div`
    width:70%;
    display:flex;
    flex-direction:row;
    justify-content:space-around;
    align-items:center;
    margin:1rem;
    @media (max-width: 768px) {
        flex-direction: column;
        justify-content:center;
        align-items:flex-start;
    }
`

const Intro1List = styled.ul`
    color: #000;
    list-style:none;
    font-size:1rem;
    margin:0; //important!
    &>li{
        line-height:2rem;
    }
` 

const Intro1Item = styled.div`
    position:relative;
    display:flex;
    flex-direction:row;
`

const Img = styled.img`
    width:70%;
    height:auto;
` 

const SmallSubtitle=styled.div`
    width:60%;
    text-align:left;
    font-size:1.3rem;
    font-weight: 700;
    @media (max-width: 1000px) {
        font-size:1.2rem;
    }
    @media (max-width: 768px) {
        font-size: 1.1rem;
    }
`

const Icon = styled.img`
    width:auto;
    height:1.3rem;
    @media (max-width: 1000px) {
        height:1.2rem;
    }
    @media (max-width: 768px) {
        height: 1.1rem;
    }
`

const SmartautomationCard = (props)=>{

const Intro2ListWrapper = styled.div`
    width:70%;
    display:flex;
    flex-direction:row;
    justify-content:space-around;
    align-items:center;
    margin:1rem;
    @media (max-width: 768px) {
        width:50%;
        flex-direction: column;
        justify-content:center;
        align-items:flex-start;
    }
`

const Intro2List = styled.ul`
    color: #000;
    list-style-type:none;
    font-size:1rem;
    margin:0; //important!
    &>li{
        line-height:2rem;
    }
`     

    const{ langCh }=props

    return(
    <>
        <Subtitle>
            {smartAutomationConfig[langCh?'ch':'en'].intro1Title}
        </Subtitle>
        <Intro1ListWrapper>   
            <Intro1List>
                {smartAutomationConfig[langCh?'ch':'en'].intro1List[0].map((data,i)=>
                    <li key={i}>
                        <div style={{fontSize:'1.2rem', fontWeight: 400}}>{data[0]}</div>
                        <Intro1Item>
                            <div>- </div>
                            <div>{data[1]}</div>
                        </Intro1Item> 
                    </li>)
                }
            </Intro1List>
            <Intro1List>
                {smartAutomationConfig[langCh?'ch':'en'].intro1List[1].map((data,i)=>
                    <li key={i}>
                        <div style={{fontSize:'1.2rem', fontWeight: 400}}>{data[0]}</div>
                        <Intro1Item>
                            <div>-</div>
                            <div>{data[1]}</div>
                        </Intro1Item> 
                    </li>)
                }
            </Intro1List>
        </Intro1ListWrapper>
        <SmallSubtitle>
            <Icon src={yellowLargerIcon}/>
            {smartAutomationConfig[langCh?'ch':'en'].flowTitle}
        </SmallSubtitle>
        <Img 
            style={{margin:'2rem 0rem'}}
            src={smartAutomationConfig[langCh?'ch':'en'].flowImg}
        />
        <SmallSubtitle>
            <Icon src={yellowLargerIcon}/>
            {smartAutomationConfig[langCh?'ch':'en'].intro2Title}
        </SmallSubtitle>
        <Intro2ListWrapper>
            {smartAutomationConfig[langCh?'ch':'en'].intro2List.map((data,i)=>
                <div key={i}>
                    <div style={{fontSize:'1.2rem', fontWeight: 400}}>{data[0]}</div>
                    {data[1].map(item=><Intro2List key={i}><li>{item}</li></Intro2List>)}
                </div>
                )
            }
        </Intro2ListWrapper>
        <Img src={smartAutomationConfig[langCh?'ch':'en'].img}/>
    </>
    )
}

export default SmartautomationCard ;